import { Reducer } from './base';

export class ScreeningPackagesMr extends Reducer {
  constructor() {
    super('screeningPackages');
  }

  handleHttpUpdatedAction(prevState, state, action) {
    if (!action.success) return state;

    const { group, data } = action;

    // Handle bulk fetch
    if (group === 'fetchScreeningPackagesBulk') {
      state = state.setIn(['packages'], data.screeningPackages || []);
      state = state.setIn(['groups'], data.screeningGroups || []);
      state = state.setIn(['accredFieldInfo'], data.accredFieldInfo || {});
      return state;
    }

    // Handle fetch screening packages
    if (group === 'fetchScreeningPackages') {
      state = state.setIn(['packages'], data || []);
      return state;
    }

    // Handle create screening package
    if (group === 'createScreeningPackage') {
      const packages = state.getIn(['packages']) || [];
      state = state.setIn(['packages'], [...packages, data]);
      return state;
    }

    // Handle update screening package
    if (group === 'updateScreeningPackage') {
      const packages = state.getIn(['packages']) || [];
      const updatedPackages = packages.map(pkg => (pkg.id === data.id ? data : pkg));
      state = state.setIn(['packages'], updatedPackages);
      return state;
    }

    // Handle delete screening package
    if (group === 'deleteScreeningPackage') {
      const packages = state.getIn(['packages']) || [];
      const filteredPackages = packages.filter(pkg => pkg.id !== action.meta.id);
      state = state.setIn(['packages'], filteredPackages);
      return state;
    }

    // Handle fetch dynamic screening groups
    if (group === 'fetchDynamicScreeningGroups') {
      state = state.setIn(['dynamicGroups'], data || []);
      return state;
    }

    // Handle fetch screening groups
    if (group === 'fetchScreeningGroups') {
      state = state.setIn(['groups'], data || []);
      return state;
    }

    // Handle create screening group
    if (group === 'createScreeningGroup') {
      const groups = state.getIn(['groups']) || [];
      state = state.setIn(['groups'], [...groups, data]);
      return state;
    }

    // Handle update screening group
    if (group === 'updateScreeningGroup') {
      const groups = state.getIn(['groups']) || [];
      const updatedGroups = groups.map(grp => (grp.id === data.id ? data : grp));
      state = state.setIn(['groups'], updatedGroups);
      return state;
    }

    // Handle delete screening group
    if (group === 'deleteScreeningGroup') {
      const groups = state.getIn(['groups']) || [];
      const filteredGroups = groups.filter(grp => grp.id !== action.meta.id);
      state = state.setIn(['groups'], filteredGroups);
      return state;
    }

    // Handle fetch accreditation definitions
    if (group === 'fetchAccreditationDefinitions') {
      state = state.setIn(['accreditationDefinitions'], data || []);
      return state;
    }

    // Handle fetch screening provider settings
    if (group === 'fetchScreeningProviderSettings') {
      state = state.setIn(['providerSettings'], data || {});
      return state;
    }

    return state;
  }
}
